import { DefaultLayout } from "~/layouts/DefaultLayout";
import { aboutContents } from "~/constants";
import { MetaHeader } from "~/components/MetaHeader";

const About: React.VFC = () => {
    return (
        <>
            <MetaHeader title={"福岡カフェ日記とは - 福岡カフェ日記 | 福岡最大級のカフェメディア"} description={"福岡のカフェをキュレーションしたメディア、福岡カフェ日記。みなさまの好きが詰まったお店を紹介しています。ページをめくるように覗いていただけると嬉しいです。"} />

            <DefaultLayout>
                <ul className="aboutItems">
                    {aboutContents.map((item, index) => (
                        <li key={index} className="aboutItem">
                            <img src={`images/shared/${item.img}`} alt={`福岡カフェ日記とは${index}`} width="249" height="360"/>
                            <div>
                                <h2>{item.title}</h2>
                                <p>{item.desc}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            </DefaultLayout>
        </>
    );
};

export default About;